import * as i18nUtils from "util/i18n";

import { arrayOf, func, node, number, shape } from "prop-types";
import React, { Component } from "react";

import Box from "pages/_components/Box";
import Button from "pages/_components/Button";
import WithPermissions from "pages/_components/WithPermissions";
import AccountsListItem from "pages/accounts/ListItem";
import WidgetList from "pages/desktop/widgets/WidgetList";
import { connect } from "react-redux";
import { selectors as widgetSelectors } from "reducers/widgets";
import { selectors as sessionSelectors } from "reducers/session";
import * as config from "util/config";
import { actions as productRequestActions } from "reducers/productRequest";
import WidgetHeader from "./_components/WidgetHeader";

class Accounts extends Component {
    static propTypes = {
        accounts: arrayOf(shape({ length: number })).isRequired,
        closeButton: node,
        dispatch: func.isRequired,
        draggableItemProps: shape({}).isRequired,
        activeEnvironment: shape({}).isRequired,
    };

    static defaultProps = {
        closeButton: null,
    };

    hasOnlyOneSimplificateAccount = () => {
        const { accounts } = this.props;

        if (accounts.length !== 1) {
            return false;
        }

        let simplicateList = config.get("accounts.subcategory.simplified");
        simplicateList = simplicateList !== null ? simplicateList.split("|") : null;

        if (simplicateList === null) {
            return false;
        }

        let simplificadas = 0;
        accounts.forEach((account) => {
            if (simplicateList.includes(account.subProductType)) {
                simplificadas += 1;
            }
        });

        return simplificadas === 1;
    };

    displayProductRequestModal = () => {
        const { dispatch } = this.props;
        dispatch(productRequestActions.modalShow("AC"));
    };

    render() {
        const { closeButton, draggableItemProps } = this.props;
        const uiAutomationProp = { "data-ui-automation": "widgetAccounts" };
        const itemsToShowButton = Number(config.get("widgets.product.maxToShow"));

        return (
            <WidgetList item={AccountsListItem} keyExtractor={(item) => item.idProduct} name="accounts">
                {(list, listLenght) => (
                    <>
                        <section
                            className="widget"
                            {...uiAutomationProp}
                            {...draggableItemProps}
                            aria-roledescription={i18nUtils.get("desktop.widgets.message.roleDescription")}>
                            <WidgetHeader title={i18nUtils.get("list.addWidget.accounts")} action={closeButton} />
                            {list}
                            <WithPermissions permissions={["accounts"]}>
                                <Box display="flex" alignX="between" fullWidth flex1 className="px-md-3" zIndex="0">
                                    {listLenght > itemsToShowButton ? (
                                        <Button href="/accounts" label="widgets.accounts.myAccounts" bsStyle="link" />
                                    ) : null}
                                </Box>
                            </WithPermissions>
                            <div className="overlay" />
                        </section>
                    </>
                )}
            </WidgetList>
        );
    }
}

const mapStateToProps = (state) => ({
    accounts: widgetSelectors.getWidgetList(state, "accounts"),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
});

export default connect(mapStateToProps)(Accounts);
